import * as apiClient from '../api/apiClient';
import { buildPagedQuery } from '../api/pagedQuery';
import { unwrapPagedResponseModel, unwrapResponseModel } from '../api/responseModel';

async function requestAndUnwrap(requestPromise) {
  const { data } = await requestPromise;
  return unwrapResponseModel(data);
}

function createPagedList(indexPath) {
  return (query = { page: 1, pageSize: 10 }) => {
    const qs = buildPagedQuery(query);
    return apiClient.get(`${indexPath}?${qs}`).then(({ data }) => unwrapPagedResponseModel(data));
  };
}

function createHistoriaAcademicaCursadaResource() {
  const listPaged = createPagedList('/api/hac/Index');
  return {
    resetForTests() {
      // Sin caché deduplicada tras F4-011.
    },
    list(query) {
      return listPaged(query);
    },
    lookup(query) {
      return listPaged({ pageSize: 5, ...query });
    },
    get(id) {
      return requestAndUnwrap(apiClient.get(`/api/hac/${id}`));
    },
    delete(id) {
      return requestAndUnwrap(apiClient.get(`/api/hac/delete/${id}`));
    },
    update(payload) {
      return requestAndUnwrap(apiClient.post('/api/hac', payload));
    },
    actualizarRegularidadesGlobal() {
      return requestAndUnwrap(apiClient.get('/api/ic/actcur'));
    },
    actualizarRegularidadesPorCarrera(carreraCod) {
      return requestAndUnwrap(apiClient.get(`/api/ic/actcur/${carreraCod}`));
    }
  };
}

function createHistoriaAcademicaExamenResource() {
  const listPaged = createPagedList('/api/hex/Index');
  return {
    resetForTests() {
      // Sin caché deduplicada tras F4-011.
    },
    list(query) {
      return listPaged(query);
    },
    lookup(query) {
      return listPaged({ pageSize: 5, ...query });
    },
    get(id) {
      return requestAndUnwrap(apiClient.get(`/api/hex/${id}`));
    },
    delete(id) {
      return requestAndUnwrap(apiClient.get(`/api/hex/delete/${id}`));
    },
    update(payload) {
      return requestAndUnwrap(apiClient.post('/api/hex', payload));
    }
  };
}

const historiaCursada = createHistoriaAcademicaCursadaResource();
const historiaExamen = createHistoriaAcademicaExamenResource();

export function resetHistoriaAcademicaCursadaListCacheForTests() {
  historiaCursada.resetForTests();
}

export function resetHistoriaAcademicaExamenListCacheForTests() {
  historiaExamen.resetForTests();
}

export function listHistoriaAcademicaCursada(query) {
  return historiaCursada.list(query);
}

export function lookupHistoriaAcademicaCursada(query) {
  return historiaCursada.lookup(query);
}

export function getHistoriaAcademicaCursada(id) {
  return historiaCursada.get(id);
}

export function deleteHistoriaAcademicaCursada(id) {
  return historiaCursada.delete(id);
}

export function updateHistoriaAcademicaCursada(payload) {
  return historiaCursada.update(payload);
}

export function actualizarRegularidadesGlobal() {
  return historiaCursada.actualizarRegularidadesGlobal();
}

export function actualizarRegularidadesPorCarrera(carreraCod) {
  return historiaCursada.actualizarRegularidadesPorCarrera(carreraCod);
}

export function listHistoriaAcademicaExamen(query) {
  return historiaExamen.list(query);
}

export function lookupHistoriaAcademicaExamen(query) {
  return historiaExamen.lookup(query);
}

export function getHistoriaAcademicaExamen(id) {
  return historiaExamen.get(id);
}

export function deleteHistoriaAcademicaExamen(id) {
  return historiaExamen.delete(id);
}

export function updateHistoriaAcademicaExamen(payload) {
  return historiaExamen.update(payload);
}
